if (!customElements.get('lc-scrolling-text')) {
  class LcScrollingText extends HTMLElement {
    constructor() {
      super();
      if (FoxTheme.config.motionReduced) return;
      this.container = this.querySelector('.lc-scrolling-text__container');
      FoxTheme.Motion.inView(this, this.init.bind(this), { margin: '200px 0px 200px 0px' });
    }
    init() {
      if (this.childElementCount === 1) {
        this.container.classList.add('lc-scrolling-text__container--animated');
        for (let index = 0; index < 10; index++) {
          this.clone = this.container.cloneNode(true);
          this.appendChild(this.clone);
        }
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.classList.remove('lc-scrolling-text--paused');
              } else {
                this.classList.add('lc-scrolling-text--paused');
              }
            });
          },
          { rootMargin: '0px 0px 50px 0px' }
        );
        observer.observe(this);
      }
    }
  }
  customElements.define('lc-scrolling-text', LcScrollingText);
}
